import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Inject, PLATFORM_ID } from '@angular/core';

declare global {
  interface Window {
    hbspt: any;        
  }
}

// <script charset="utf-8" type="text/javascript" src="//js-eu1.hsforms.net/forms/embed/v2.js"></script>
// <script>
//   hbspt.forms.create({
//     portalId: "143341037",
//     formId: "cccf7f64-acf6-4c7e-a9d6-5618c6e9cd04",
//     region: "eu1"
//   });
// </script>


@Component({
  selector: 'fc-hubspot-form-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hubspot-form-component.component.html',
  styleUrls: ['./hubspot-form-component.component.scss']
})
export class HubspotFormComponentComponent implements AfterViewInit {
  constructor(
    private host: ElementRef<HTMLElement>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  async ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId)) { return; }          // skip on SSR

    // 1. Load the HubSpot form library once per app
    await this.loadHubspotScript();

    // 2. Render the form into the wrapper div
    window.hbspt.forms.create({
      portalId: '143341037',
      formId:   'cccf7f64-acf6-4c7e-a9d6-5618c6e9cd04',
      target:   '#hs-form-wrapper',
      css: '',                
      onFormReady: () => console.log('HubSpot form ready'),
      onFormSubmit: () => console.log('submitted!'),
    });
  }

  private loadHubspotScript(): Promise<void> {
    return new Promise(resolve => {
      const existing = document.querySelector(
        'script[src="//js.hsforms.net/forms/v2.js"]'
      );
      if (existing) { resolve(); return; }

      const s = document.createElement('script');
      s.src = '//js.hsforms.net/forms/v2.js';
      s.async = true;
      s.onload = () => resolve();
      document.head.appendChild(s);
    });
  }
}